export const avatarColors = [
  '#638a30',
  '#924dc4',
  '#5bba50',
  '#cd78e3',
  '#b4b439',
  '#6171de',
  '#de9535',
  '#6583c8',
  '#cb5528',
  '#46aed7',
  '#d4424c',
  '#55c1a1',
  '#c22e89',
  '#3b8556',
  '#e55fbb',
  '#a7b46d',
  '#a94890',
  '#6e6a27',
  '#7d58a4',
  '#ab7d3c',
  '#c792d1',
  '#e48f6f',
  '#974e74',
  '#a35146',
  '#d24072',
  '#e4819f'
];
